import React, { useState } from 'react';
import { FaRegCopy, FaCheck } from 'react-icons/fa';

interface CopyButtonProps {
  text: string;
  className?: string;
  size?: number;
  tooltip?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  className = '',
  size = 14,
  tooltip = 'Copy to clipboard',
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // Clipboard write may reject when the page isn't focused — swallow.
    }
  };

  return (
    <button
      type="button"
      className={`flex items-center hover:text-amber-500 dark:hover:text-amber-400 ${className}`}
      onClick={handleCopy}
      title={copied ? 'Copied!' : tooltip}
      aria-label={copied ? 'Copied!' : tooltip}
    >
      {copied ? <FaCheck size={size} className="text-green-600 dark:text-green-400" /> : <FaRegCopy size={size} />}
    </button>
  );
};

export default CopyButton;
